/**
 * Tracks open app modals so chrome (e.g. Sidebar mobile menu) can hide or deprioritize
 * while a dialog is visible. Supports stacked modals via ref count.
 */
let openCount = 0
const listeners = new Set<() => void>()

function syncBodyClass() {
  if (typeof document === 'undefined') return
  document.body.classList.toggle('modal-open', openCount > 0)
}

export function getModalLayerOpen(): boolean {
  return openCount > 0
}

export function subscribeModalLayer(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function pushModalLayer(): void {
  openCount += 1
  syncBodyClass()
  listeners.forEach((l) => l())
}

export function popModalLayer(): void {
  openCount = Math.max(0, openCount - 1)
  syncBodyClass()
  listeners.forEach((l) => l())
}
